import React, { createContext, useState, useContext } from 'react';

const translations = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.products': 'Products',
    'nav.cart': 'Cart',
    'nav.orders': 'My Orders',
    'nav.profile': 'Profile',
    'nav.admin': 'Admin',
    'nav.login': 'Login',
    'nav.register': 'Register',
    'nav.logout': 'Logout',

    // Home
    'home.welcome': 'Welcome to Tonisco',
    'home.subtitle': 'Your trusted partner for quality products',
    'home.viewProducts': 'View Products',
    'home.aboutTitle': 'About Tonisco',
    'home.aboutText': 'We provide quality products with excellent customer service. Register to see our full catalog with prices and availability.',

    // Products
    'products.title': 'Our Products',
    'products.price': 'Price',
    'products.stock': 'In Stock',
    'products.inStock': 'Available',
    'products.outOfStock': 'Out of stock',
    'products.addToCart': 'Add to Cart',
    'products.viewDetails': 'View Details',
    'products.loginToSee': 'Login to see prices and stock',
    'products.linkedTitle': 'Frequently ordered together',
    'products.searchPlaceholder': 'Search products...',
    'products.selectCategory': 'Select category',
    'products.selectSubcategory': 'Select subcategory',
    'products.chooseMainCategory': 'Choose a main category',
    'products.chooseSubcategory': 'Choose a subcategory',
    'products.backToCategories': 'Back to main categories',
    'products.backToSubcategories': 'Back to subcategories',
    'products.browseStep': 'Browse catalog',
    'products.selectCategorySubcategoryPrompt': 'Select a category and subcategory to view products.',
    'products.allCategories': 'All Categories',
    'products.allManufacturers': 'All Manufacturers',
    'products.inStockOnly': 'In Stock Only',
    'products.clearFilters': 'Clear Filters',
    'products.showing': 'Showing',
    'products.productSingular': 'product',
    'products.productPlural': 'products',
    'products.noResults': 'No products found matching your criteria.',
    'products.noProducts': 'No products available',
    'products.notFound': 'Product not found',
    'products.noImages': 'No Images Available',
    'products.outOfStockAlert': 'Out of stock',
    'products.noMedia': 'No Media',
    'products.noCategory': 'No category',
    'products.noSubcategory': 'No Subcategory',
    'products.openManual': 'Open manual',

    // Cart
    'cart.title': 'Shopping Cart',
    'cart.empty': 'Your cart is empty',
    'cart.total': 'Total',
    'cart.checkout': 'Checkout',
    'cart.remove': 'Remove',
    'cart.quantity': 'Quantity',
    'cart.columns.product': 'Product',
    'cart.columns.price': 'Price',
    'cart.columns.subtotal': 'Subtotal',
    'cart.columns.actions': 'Actions',
    'cart.confirmRemoveTitle': 'Remove item',
    'cart.confirmRemoveMessage': 'Remove this product from the cart?',
    'cart.orderCreated': 'Order created',
    'cart.orderNumber': 'Order number:',
    'cart.checkoutTitle': 'Checkout',
    'cart.additionalEmailLabel': 'Additional Email (optional)',
    'cart.additionalEmailPlaceholder': 'Additional recipient for order confirmation',
    'cart.notesLabel': 'Order Notes (optional)',
    'cart.notesPlaceholder': 'Any special instructions or comments',
    'cart.orderTotal': 'Order Total:',
    'cart.confirmOrder': 'Confirm Order',
    'cart.deliveryInformation': 'Delivery Information',
    'cart.deliveryStreetAddressLabel': 'Street Address',
    'cart.deliveryStreetAddressPlaceholder': 'Street address',
    'cart.deliveryPostalCodeLabel': 'Postal Code',
    'cart.deliveryPostalCodePlaceholder': 'Postal code',
    'cart.deliveryCityLabel': 'City',
    'cart.deliveryCityPlaceholder': 'City',
    'cart.deliveryDateLabel': 'Delivery Date',
    'orders.deliveryInformation': 'Delivery Information',
    'orders.deliveryStreetAddress': 'Street Address',
    'orders.deliveryPostalCode': 'Postal Code',
    'orders.deliveryCity': 'City',
    'orders.deliveryDate': 'Delivery Date',

    // Orders
    'orders.title': 'My Orders',
    'orders.number': 'Order Number',
    'orders.date': 'Date',
    'orders.status': 'Status',
    'orders.total': 'Total',
    'orders.viewDetails': 'View Details',
    'orders.noOrders': 'No orders yet',
    'orders.items': 'Order Items',
    'orders.columns.product': 'Product',
    'orders.columns.quantity': 'Quantity',
    'orders.columns.price': 'Price',
    'orders.columns.subtotal': 'Subtotal',
    'orders.notes': 'Order Notes:',
    'orders.resend': 'Resend',
    'orders.resendConfirmation': 'Resend Confirmation',
    'orders.downloadPdf': 'Download Order Confirmation (PDF)',
    'orders.resendTitle': 'Resend Order Confirmation',
    'orders.emailAddresses': 'Email addresses',
    'orders.emailSeparatorHint': 'Separate multiple addresses with commas',
    'orders.emailRequired': 'Please provide at least one email address.',
    'orders.resendSuccess': 'Order confirmation resent!',
    'orders.resendFailed': 'Failed to resend order confirmation.',
    'orders.sending': 'Sending...',
    'orders.send': 'Send',

    // Profile
    'profile.title': 'My Profile',
    'profile.accountInfo': 'Account Information',
    'profile.company': 'Company (Optional)',
    'profile.orderEmails': 'Order Confirmation Emails (Optional)',
    'profile.orderEmailsHint': 'Comma-separated default recipients for your order confirmations.',
    'profile.changePassword': 'Change Password (Optional)',
    'profile.currentPassword': 'Current Password',
    'profile.newPassword': 'New Password',
    'profile.confirmPassword': 'Confirm New Password',
    'profile.passwordPlaceholder': 'Leave blank to keep current password',
    'profile.confirmPasswordPlaceholder': 'Confirm new password',
    'profile.updateProfile': 'Update Profile',
    'profile.shippingAddress': 'Shipping Address',
    'profile.addressLine1': 'Address Line 1',
    'profile.addressLine2': 'Address Line 2 (Optional)',
    'profile.stateProvince': 'State/Province (Optional)',
    'profile.phone': 'Phone (Optional)',
    'profile.updateAddress': 'Update Address',
    'profile.saving': 'Saving...',
    'profile.errorLoad': 'Failed to load profile',
    'profile.errorCurrentPwd': 'Please enter your current password',
    'profile.errorPwdMismatch': 'New passwords do not match',
    'profile.errorPwdTooShort': 'New password must be at least 6 characters',
    'profile.successUpdated': 'Profile updated successfully!',
    'profile.successAddress': 'Address updated successfully!',

    // Auth
    'auth.username': 'Username',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.company': 'Company',
    'auth.address': 'Address',
    'auth.city': 'City',
    'auth.postalCode': 'Postal Code',
    'auth.country': 'Country',
    'auth.phone': 'Phone',
    'auth.login': 'Login',
    'auth.register': 'Register',
    'auth.loginTitle': 'Login to Your Account',
    'auth.registerTitle': 'Create New Account',
    'auth.or': 'or',
    'auth.continueGoogle': 'Continue with Google',
    'auth.accountDetails': 'Account Details',
    'auth.addressDetails': 'Address Details',
    'auth.stateProvince': 'State/Province',
    'auth.streetAddressPlaceholder': 'Street address',
    'auth.addressLine2Placeholder': 'Apartment, suite, etc. (optional)',
    'auth.alreadyHaveAccount': 'Already have an account?',
    'auth.noAccount': "Don't have an account?",
    'auth.contactAdminForAccess': 'Contact an administrator if you need an account.',
    'auth.loginFailed': 'Login failed',
    'auth.ssoFailed': 'SSO login failed',
    'auth.registrationFailed': 'Registration failed',
    'auth.forgotPassword': 'Forgot password?',
    'auth.forgotPasswordTitle': 'Reset Password',
    'auth.forgotPasswordInstructions': 'Enter your username and we will send a password reset link to the associated email address.',
    'auth.forgotPasswordSubmit': 'Send Reset Link',
    'auth.forgotPasswordSent': 'If that username exists, a password reset link has been sent to the associated email address.',
    'auth.forgotPasswordFailed': 'Failed to send reset link',
    'auth.backToLogin': 'Back to login',

    // Admin
    'admin.products': 'Manage Products',
    'admin.orders': 'All Orders',
    'admin.settings': 'Site Settings',
    'admin.users': 'Users',
    'admin.addProduct': 'Add Product',
    'admin.editProduct': 'Edit Product',
    'admin.dashboard': 'Admin Dashboard',
    'admin.categories': 'Categories',
    'admin.addCategory': 'Add Category',
    'admin.editCategory': 'Edit Category',
    'admin.manageBranding': 'Manage Branding',
    'admin.manageUsers': 'Manage Users',
    'admin.manageCategories': 'Manage Categories',
    'admin.viewOrders': 'View Orders',
    'admin.manageProductsDesc': 'Manage product catalog, add new products, upload images',
    'admin.manageCatalogDesc': 'Browse and organize catalog tree with drag and drop',
    'admin.expandAll': 'Expand all',
    'admin.collapseAll': 'Collapse all',
    'admin.manageCategoriesDesc': 'Manage product categories and subcategories',
    'admin.manageOrdersDesc': 'View all orders, update order status',
    'admin.manageUsersDesc': 'Manage user accounts, block/unblock users',
    'admin.manageSettingsDesc': 'Configure site settings, landing page, email settings',
    'admin.manageBrandingDesc': 'Customize logo, colors, and brand identity',
    'admin.noOrders': 'No orders yet',
    'admin.customer': 'Customer',
    'admin.company': 'Company',
    'admin.date': 'Date',
    'admin.filterProducts': 'Filter products',
    'admin.productListTab': 'Product List',
    'admin.catalogTab': 'Catalog',
    'admin.filterCategories': 'Filter categories',
    'admin.filterUsers': 'Filter users',
    'admin.bulkAction': 'Bulk action',
    'admin.selectAction': 'Select action',
    'admin.applying': 'Applying...',
    'admin.apply': 'Apply',
    'admin.visible': 'Visible',
    'admin.hidden': 'Hidden',
    'admin.exportExcel': 'Export to Excel',
    'admin.importExcel': 'Import from Excel',
    'admin.deleteSelected': 'Delete Selected',
    'admin.deleting': 'Deleting...',
    'admin.selected': 'Selected:',
    'admin.userManagement': 'User Management',
    'admin.addUser': 'Add User',
    'admin.editUser': 'Edit User',
    'admin.importUsers': 'Import Users',
    'admin.downloadTemplate': 'Download Template',
    'admin.selectExcelFile': 'Select Excel file',
    'admin.createdCount': 'Created',
    'admin.updatedCount': 'Updated',
    'admin.id': 'ID',
    'admin.name': 'Name',
    'admin.manufacturer': 'Manufacturer',
    'admin.category': 'Category',
    'admin.price': 'Price',
    'admin.stock': 'Stock',
    'admin.images': 'Images',
    'admin.actions': 'Actions',
    'admin.orderConfirmationEmailsCol': 'Order Confirmation Emails',
    'admin.role': 'Role',
    'admin.registered': 'Registered',
    'admin.active': 'Active',
    'admin.blocked': 'Blocked',
    'admin.block': 'Block',
    'admin.unblock': 'Unblock',
    'admin.anonymize': 'Anonymize',
    'admin.blockUser': 'Block User',
    'admin.anonymizeUser': 'Anonymize User',
    'admin.brandingSettings': 'Branding Settings',
    'admin.logo': 'Logo',
    'admin.uploadLogo': 'Upload Logo',
    'admin.deleteLogo': 'Delete Logo',
    'admin.colorPalette': 'Color Palette',
    'admin.colorPreview': 'Color Preview',
    'admin.saveColors': 'Save Colors',
    'admin.resetToDefaults': 'Reset to Defaults',
    'admin.landingSettings': 'Landing Page Settings',
    'admin.emailSettings': 'Email Settings',
    'admin.resendTitle': 'Resend Order Confirmation',
    'admin.emailAddresses': 'Email addresses',
    'admin.emailSeparatorHint': 'Separate multiple addresses with commas',
    'admin.sending': 'Sending...',
    'admin.send': 'Send',
    'admin.externalId': 'External ID',
    'admin.additionalEmail': 'Additional Email:',
    'admin.update': 'Update',
    'admin.status': 'Status',
    'admin.notes': 'Notes:',
    'admin.userRole': 'User',
    'admin.managerRole': 'Manager',
    'admin.adminRole': 'Admin',
    'admin.orderNumber': 'Order #',
    'admin.sendResetLink': 'Send Reset Link',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.success': 'Success!',
    'common.saving': 'Saving...',
    'common.na': 'N/A',
  },
  fi: {
    // Navigation
    'nav.home': 'Etusivu',
    'nav.products': 'Tuotteet',
    'nav.cart': 'Ostoskori',
    'nav.orders': 'Tilaukset',
    'nav.profile': 'Profiili',
    'nav.admin': 'Hallinta',
    'nav.login': 'Kirjaudu',
    'nav.register': 'Rekisteröidy',
    'nav.logout': 'Kirjaudu ulos',

    // Home
    'home.welcome': 'Tervetuloa Toniscoon',
    'home.subtitle': 'Luotettava kumppanisi laadukkaissa tuotteissa',
    'home.viewProducts': 'Katso tuotteet',
    'home.aboutTitle': 'Tietoa Toniscosta',
    'home.aboutText': 'Tarjoamme laadukkaita tuotteita erinomaisella asiakaspalvelulla. Rekisteröidy nähdäksesi koko katalogimme hinnoilla ja saatavuudella.',

    // Products
    'products.title': 'Tuotteemme',
    'products.price': 'Hinta',
    'products.stock': 'Varastossa',
    'products.inStock': 'Saatavilla',
    'products.outOfStock': 'Loppu varastosta',
    'products.addToCart': 'Lisää koriin',
    'products.viewDetails': 'Näytä tiedot',
    'products.loginToSee': 'Kirjaudu nähdäksesi hinnat ja varastotilanteen',
    'products.linkedTitle': 'Usein tilataan yhdessä',
    'products.searchPlaceholder': 'Hae tuotteita...',
    'products.selectCategory': 'Valitse kategoria',
    'products.selectSubcategory': 'Valitse alakategoria',
    'products.chooseMainCategory': 'Valitse pääkategoria',
    'products.chooseSubcategory': 'Valitse alakategoria',
    'products.backToCategories': 'Takaisin pääkategorioihin',
    'products.backToSubcategories': 'Takaisin alakategorioihin',
    'products.browseStep': 'Selaa valikoimaa',
    'products.selectCategorySubcategoryPrompt': 'Valitse kategoria ja alakategoria nähdäksesi tuotteet.',
    'products.allCategories': 'Kaikki kategoriat',
    'products.allManufacturers': 'Kaikki valmistajat',
    'products.inStockOnly': 'Vain saatavilla',
    'products.clearFilters': 'Tyhjennä suodattimet',
    'products.showing': 'Näytetään',
    'products.productSingular': 'tuote',
    'products.productPlural': 'tuotetta',
    'products.noResults': 'Tuotteita ei löytynyt annetuilla hakuehdoilla.',
    'products.noProducts': 'Ei saatavilla olevia tuotteita',
    'products.notFound': 'Tuotetta ei löydy',
    'products.noImages': 'Ei kuvia saatavilla',
    'products.outOfStockAlert': 'Loppu varastosta',
    'products.noMedia': 'Ei mediaa',
    'products.noCategory': 'Ei kategoriaa',
    'products.noSubcategory': 'Ei alakategoriaa',
    'products.openManual': 'Avaa käyttöohje',

    // Cart
    'cart.title': 'Ostoskori',
    'cart.empty': 'Ostoskorisi on tyhjä',
    'cart.total': 'Yhteensä',
    'cart.checkout': 'Tilaa',
    'cart.remove': 'Poista',
    'cart.quantity': 'Määrä',
    'cart.columns.product': 'Tuote',
    'cart.columns.price': 'Hinta',
    'cart.columns.subtotal': 'Välisumma',
    'cart.columns.actions': 'Toiminnot',
    'cart.confirmRemoveTitle': 'Poista tuote',
    'cart.confirmRemoveMessage': 'Poistetaanko tämä tuote ostoskorista?',
    'cart.orderCreated': 'Tilaus luotu',
    'cart.orderNumber': 'Tilausnumero:',
    'cart.checkoutTitle': 'Tilaa',
    'cart.additionalEmailLabel': 'Lisäsähköposti (valinnainen)',
    'cart.additionalEmailPlaceholder': 'Lisävastaanottaja tilausvahvistukselle',
    'cart.notesLabel': 'Tilaushuomiot (valinnainen)',
    'cart.notesPlaceholder': 'Erityisohjeet tai kommentit',
    'cart.orderTotal': 'Tilauksen kokonaissumma:',
    'cart.confirmOrder': 'Vahvista tilaus',
    'cart.deliveryInformation': 'Toimitusosoite',
    'cart.deliveryStreetAddressLabel': 'Katuosoite',
    'cart.deliveryStreetAddressPlaceholder': 'Katuosoite',
    'cart.deliveryPostalCodeLabel': 'Postinumero',
    'cart.deliveryPostalCodePlaceholder': 'Postinumero',
    'cart.deliveryCityLabel': 'Kaupunki',
    'cart.deliveryCityPlaceholder': 'Kaupunki',
    'cart.deliveryDateLabel': 'Toimituspäivä',
    'orders.deliveryInformation': 'Toimitusosoite',
    'orders.deliveryStreetAddress': 'Katuosoite',
    'orders.deliveryPostalCode': 'Postinumero',
    'orders.deliveryCity': 'Kaupunki',
    'orders.deliveryDate': 'Toimituspäivä',

    // Orders
    'orders.title': 'Tilaukseni',
    'orders.number': 'Tilausnumero',
    'orders.date': 'Päivämäärä',
    'orders.status': 'Tila',
    'orders.total': 'Yhteensä',
    'orders.viewDetails': 'Näytä tiedot',
    'orders.noOrders': 'Ei tilauksia vielä',
    'orders.items': 'Tilausrivit',
    'orders.columns.product': 'Tuote',
    'orders.columns.quantity': 'Määrä',
    'orders.columns.price': 'Hinta',
    'orders.columns.subtotal': 'Välisumma',
    'orders.notes': 'Tilaushuomiot:',
    'orders.resend': 'Lähetä uudelleen',
    'orders.resendConfirmation': 'Lähetä vahvistus uudelleen',
    'orders.downloadPdf': 'Lataa tilausvahvistus (PDF)',
    'orders.resendTitle': 'Lähetä tilausvahvistus uudelleen',
    'orders.emailAddresses': 'Sähköpostiosoitteet',
    'orders.emailSeparatorHint': 'Erota useampi osoite pilkulla',
    'orders.emailRequired': 'Anna ainakin yksi sähköpostiosoite.',
    'orders.resendSuccess': 'Tilausvahvistus lähetetty uudelleen!',
    'orders.resendFailed': 'Tilausvahvistuksen uudelleenlähetys epäonnistui.',
    'orders.sending': 'Lähetetään...',
    'orders.send': 'Lähetä',

    // Profile
    'profile.title': 'Profiilini',
    'profile.accountInfo': 'Tilitiedot',
    'profile.company': 'Yritys (valinnainen)',
    'profile.orderEmails': 'Tilausvahvistussähköpostit (valinnainen)',
    'profile.orderEmailsHint': 'Pilkulla erotetut oletusvastaanottajat tilausvahvistuksillesi.',
    'profile.changePassword': 'Vaihda salasana (valinnainen)',
    'profile.currentPassword': 'Nykyinen salasana',
    'profile.newPassword': 'Uusi salasana',
    'profile.confirmPassword': 'Vahvista uusi salasana',
    'profile.passwordPlaceholder': 'Jätä tyhjäksi säilyttääksesi nykyisen salasanan',
    'profile.confirmPasswordPlaceholder': 'Vahvista uusi salasana',
    'profile.updateProfile': 'Päivitä profiili',
    'profile.shippingAddress': 'Toimitusosoite',
    'profile.addressLine1': 'Osoiterivi 1',
    'profile.addressLine2': 'Osoiterivi 2 (valinnainen)',
    'profile.stateProvince': 'Osavaltio/Maakunta (valinnainen)',
    'profile.phone': 'Puhelin (valinnainen)',
    'profile.updateAddress': 'Päivitä osoite',
    'profile.saving': 'Tallennetaan...',
    'profile.errorLoad': 'Profiilin lataus epäonnistui',
    'profile.errorCurrentPwd': 'Syötä nykyinen salasana',
    'profile.errorPwdMismatch': 'Uudet salasanat eivät täsmää',
    'profile.errorPwdTooShort': 'Uuden salasanan tulee olla vähintään 6 merkkiä',
    'profile.successUpdated': 'Profiili päivitetty onnistuneesti!',
    'profile.successAddress': 'Osoite päivitetty onnistuneesti!',

    // Auth
    'auth.username': 'Käyttäjätunnus',
    'auth.email': 'Sähköposti',
    'auth.password': 'Salasana',
    'auth.company': 'Yritys',
    'auth.address': 'Osoite',
    'auth.city': 'Kaupunki',
    'auth.postalCode': 'Postinumero',
    'auth.country': 'Maa',
    'auth.phone': 'Puhelin',
    'auth.login': 'Kirjaudu',
    'auth.register': 'Rekisteröidy',
    'auth.loginTitle': 'Kirjaudu tilillesi',
    'auth.registerTitle': 'Luo uusi tili',
    'auth.or': 'tai',
    'auth.continueGoogle': 'Jatka Googlella',
    'auth.accountDetails': 'Tilin tiedot',
    'auth.addressDetails': 'Osoitetiedot',
    'auth.stateProvince': 'Osavaltio/Maakunta',
    'auth.streetAddressPlaceholder': 'Katuosoite',
    'auth.addressLine2Placeholder': 'Asunto, toimisto jne. (valinnainen)',
    'auth.alreadyHaveAccount': 'Onko sinulla jo tili?',
    'auth.noAccount': 'Eikö sinulla ole tiliä?',
    'auth.contactAdminForAccess': 'Ota yhteyttä ylläpitäjään, jos tarvitset käyttäjätilin.',
    'auth.loginFailed': 'Kirjautuminen epäonnistui',
    'auth.ssoFailed': 'SSO-kirjautuminen epäonnistui',
    'auth.registrationFailed': 'Rekisteröityminen epäonnistui',
    'auth.forgotPassword': 'Unohditko salasanan?',
    'auth.forgotPasswordTitle': 'Nollaa salasana',
    'auth.forgotPasswordInstructions': 'Syötä käyttäjätunnuksesi, niin lähetämme salasanan palautuslinkin siihen liitettyyn sähköpostiosoitteeseen.',
    'auth.forgotPasswordSubmit': 'Lähetä palautuslinkki',
    'auth.forgotPasswordSent': 'Jos käyttäjätunnus on olemassa, salasanan palautuslinkki on lähetetty siihen liitettyyn sähköpostiosoitteeseen.',
    'auth.forgotPasswordFailed': 'Palautuslinkin lähettäminen epäonnistui',
    'auth.backToLogin': 'Takaisin kirjautumiseen',

    // Admin
    'admin.products': 'Tuotteiden hallinta',
    'admin.orders': 'Kaikki tilaukset',
    'admin.settings': 'Sivuston asetukset',
    'admin.users': 'Käyttäjät',
    'admin.addProduct': 'Lisää tuote',
    'admin.editProduct': 'Muokkaa tuotetta',
    'admin.dashboard': 'Hallintapaneeli',
    'admin.categories': 'Kategoriat',
    'admin.addCategory': 'Lisää kategoria',
    'admin.editCategory': 'Muokkaa kategoriaa',
    'admin.manageBranding': 'Hallitse brändiä',
    'admin.manageUsers': 'Hallitse käyttäjiä',
    'admin.manageCategories': 'Hallitse kategoriat',
    'admin.viewOrders': 'Näytä tilaukset',
    'admin.manageProductsDesc': 'Hallitse tuotekatalogoa, lisää uusia tuotteita, lataa kuvia',
    'admin.manageCatalogDesc': 'Selaa ja jarjesta katalogipuuta raahaamalla',
    'admin.expandAll': 'Laajenna kaikki',
    'admin.collapseAll': 'Sulje kaikki',
    'admin.manageCategoriesDesc': 'Hallitse tuotekategorioita ja alakategorioita',
    'admin.manageOrdersDesc': 'Näytä kaikki tilaukset, päivitä tilauksen tila',
    'admin.manageUsersDesc': 'Hallitse käyttäjätilejä, estä/poista esto käyttäjille',
    'admin.manageSettingsDesc': 'Konfiguroi sivuston asetukset, aloitussivu, sähköpostiasetukset',
    'admin.manageBrandingDesc': 'Muokkaa logoa, värejä ja brändi-identiteettiä',
    'admin.noOrders': 'Ei tilauksia vielä',
    'admin.customer': 'Asiakas',
    'admin.company': 'Yritys',
    'admin.date': 'Päivämäärä',
    'admin.filterProducts': 'Suodata tuotteet',
    'admin.productListTab': 'Tuotelista',
    'admin.catalogTab': 'Katalogi',
    'admin.filterCategories': 'Suodata kategoriat',
    'admin.filterUsers': 'Suodata käyttäjät',
    'admin.bulkAction': 'Joukkomuutos',
    'admin.selectAction': 'Valitse toiminto',
    'admin.applying': 'Käsitellään...',
    'admin.apply': 'Käytä',
    'admin.visible': 'Näkyvissä',
    'admin.hidden': 'Piilotettu',
    'admin.exportExcel': 'Vie Exceliin',
    'admin.importExcel': 'Tuo Excelistä',
    'admin.deleteSelected': 'Poista valitut',
    'admin.deleting': 'Poistetaan...',
    'admin.selected': 'Valittu:',
    'admin.userManagement': 'Käyttäjähallinta',
    'admin.addUser': 'Lisää käyttäjä',
    'admin.editUser': 'Muokkaa käyttäjää',
    'admin.importUsers': 'Tuo käyttäjiä',
    'admin.downloadTemplate': 'Lataa malli',
    'admin.selectExcelFile': 'Valitse Excel-tiedosto',
    'admin.createdCount': 'Luotu',
    'admin.updatedCount': 'Päivitetty',
    'admin.id': 'ID',
    'admin.name': 'Nimi',
    'admin.manufacturer': 'Valmistaja',
    'admin.category': 'Kategoria',
    'admin.price': 'Hinta',
    'admin.stock': 'Varasto',
    'admin.images': 'Kuvat',
    'admin.actions': 'Toiminnot',
    'admin.orderConfirmationEmailsCol': 'Tilausvahvistussähköpostit',
    'admin.role': 'Rooli',
    'admin.registered': 'Rekisteröityi',
    'admin.active': 'Aktiivinen',
    'admin.blocked': 'Estetty',
    'admin.block': 'Estä',
    'admin.unblock': 'Poista esto',
    'admin.anonymize': 'Anonymisoi',
    'admin.blockUser': 'Estä käyttäjä',
    'admin.anonymizeUser': 'Anonymisoi käyttäjä',
    'admin.brandingSettings': 'Brändinasetukset',
    'admin.logo': 'Logo',
    'admin.uploadLogo': 'Lataa logo',
    'admin.deleteLogo': 'Poista logo',
    'admin.colorPalette': 'Väripaletti',
    'admin.colorPreview': 'Värien esikatselu',
    'admin.saveColors': 'Tallenna värit',
    'admin.resetToDefaults': 'Palauta oletukset',
    'admin.landingSettings': 'Aloitussivu-asetukset',
    'admin.emailSettings': 'Sähköpostiasetukset',
    'admin.resendTitle': 'Lähetä tilausvahvistus uudelleen',
    'admin.emailAddresses': 'Sähköpostiosoitteet',
    'admin.emailSeparatorHint': 'Erota useampi osoite pilkulla',
    'admin.sending': 'Lähetetään...',
    'admin.send': 'Lähetä',
    'admin.externalId': 'Ulkoinen ID',
    'admin.additionalEmail': 'Lisäsähköposti:',
    'admin.update': 'Päivitä',
    'admin.status': 'Tila',
    'admin.notes': 'Huomiot:',
    'admin.userRole': 'Käyttäjä',
    'admin.managerRole': 'Esimies',
    'admin.adminRole': 'Admin',
    'admin.orderNumber': 'Tilaus #',
    'admin.sendResetLink': 'Lähetä salasanan palautuslinkki',

    // Common
    'common.save': 'Tallenna',
    'common.cancel': 'Peruuta',
    'common.delete': 'Poista',
    'common.edit': 'Muokkaa',
    'common.loading': 'Ladataan...',
    'common.error': 'Tapahtui virhe',
    'common.success': 'Onnistui!',
    'common.saving': 'Tallennetaan...',
    'common.na': 'Ei saatavilla',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
